import { createAction, props } from '@ngrx/store';

export const initPresentationMode = createAction(
  '[API] Default presentation mode set',
  props<{ isPresentationMode: boolean }>()
);

export const togglePresentationMode = createAction('[Page] Toggle presentation mode');
